import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from './locales/en.json';
import translationTR from './locales/tr.json';
import { useCurrencyStore } from '../stores/currencyStore';

const resources = {
  en: {
    translation: translationEN,
  },
  tr: {
    translation: translationTR,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  });

// Set default currency based on language
i18n.on('languageChanged', (lng) => {
  const { setCurrency } = useCurrencyStore.getState();
  
  // Only set default currency if user hasn't manually changed it
  const storedCurrency = localStorage.getItem('broiler-currency-storage');
  if (!storedCurrency) {
    if (lng === 'tr') {
      setCurrency('TRY');
    } else {
      // İngilizce için varsayılan dolar
      setCurrency('USD');
    }
  }
});

export default i18n;
